import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  CloseRegister,
  OpenRegister,
  Register,
  RegisterStatus,
  SearchClosingsParams,
  SearchClosingsResult
} from '../../../../core/models/register.model';
import { RegisterServiceAdapter } from '../../../../core/integrations/nosERP/services/register.service.adapter';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  private registers: BehaviorSubject<Register[]> = new BehaviorSubject<Register[]>([]);
  private closingStatus: BehaviorSubject<{ status: RegisterStatus }> = new BehaviorSubject<{
    status: RegisterStatus;
  }>({ status: RegisterStatus.NONE_OPEN }); // Default value

  constructor(private registerServiceAdapter: RegisterServiceAdapter) {}

  /**
   * Returns all registers as an observable
   */
  getAllRegisters(): Observable<Register[]> {
    return this.registerServiceAdapter.getAllRegisters();
  }

  /**
   * Dynamically determines the current register
   */
  // get currentRegister(): Register | null {
  //     return this.registerServiceAdapter.currentRegister;
  // }

  /**
   * Open a new register
   * @param params - Parameters to open the register
   */
  openRegister(params: OpenRegister): Observable<{ status: RegisterStatus }> {
    return this.registerServiceAdapter.openRegister(params);
  }

  /**
   * Search for closings
   * @param params - Parameters for searching the closings
   */
  searchClosings(params: SearchClosingsParams): Observable<SearchClosingsResult> {
    return this.registerServiceAdapter.searchClosings(params);
  }

  /**
   * Returns a shared observable of the closing status
   */
  get closingStatus$(): Observable<{ status: RegisterStatus }> {
    return this.registerServiceAdapter.closingStatus$;
  }

  /**
   * Fetches the closing status based on the current Register and the user
   * @param idUser - ID of the user
   * @param registerId - Optional Register ID
   * @returns Observable<{ status: RegisterStatus }>
   */
  getClosingStatus(idUser: number, registerId?: number): Observable<{ status: RegisterStatus }> {
    return this.registerServiceAdapter.getClosingStatus(idUser, registerId);
  }

  /**
   * Close the current register
   * @param params - Parameters to close the register
   */
  closeRegister(params: CloseRegister): Observable<{ status: number }> {
    return this.registerServiceAdapter.closeRegister(params);
  }

  searchFechoDetails(payload: any): Observable<any> {
    return this.registerServiceAdapter.searchFechoDetails(payload);
  }

  updateRegisterPrinterConfig(payload: { id_utilizador: number; id_banco: number; ip: string; porta: string }): Observable<any> {
    return this.registerServiceAdapter.updateRegisterPrinterConfig(payload);
  }
}
